{
  "api": {
    "navigation_title": "Claves de API",
    "create_token": "Crear clave de API",
    "docs": "Documentos API",
    "title": "Claves de API",
    "filter_input": "Filtrar claves de API...",
    "remove_token": "Eliminar clave de API",
    "select_org": "Seleccionar organización",
    "never_used": "Nunca se utilizó",
    "dialogs": {
      "delete": {
        "title": "¿Está seguro?",
        "content": "¿Está seguro de que desea eliminar esta clave de API? No puede deshacer esta acción"
      }
    },
    "token": "Clave",
    "organization": "Organización",
    "created": "Creado por",
    "device": "Alcance del dispositivo",
    "permissions": "Permisos",
    "requests_number": "Solicitudes",
    "last_used_at": "Último uso"
  }
}
